import Chatrooms from "./Chatrooms";

export default Chatrooms;
